export const SIGN_IN = 'SIGN_IN';
export const SIGN_OUT = 'SIGN_OUT';
export const CREATE_USER = 'CREATE_USER';
export const DELETE_USER = 'DELETE_USER';
// export const UPDATE_USER = 'UPDATE_USER';
export const KITH_USER = "KITH_USER"
export const AUTH_ERROR = "AUTH_ERROR"
export const FORGOT_PASSWORD = "FORGOT_PASSWORD"
export const GET_USER_PURCHASES = "GET_USER_PURCHASES"
export const PULLING_PURCHASES = "PULLING_PURCHASES"